import { useEffect } from "react";
import { userManager } from "../auth/oidc";

export default function SilentRenew() {
  useEffect(() => {
    userManager.signinSilentCallback();
  }, []);
  return <div />;
}
